import { CollapsedMenuItem } from "./CollapsedMenuItem";
import { ExpandedMenuItem } from "./ExpandedMenuItem";
import { SimpleMenuItem } from "./SimpleMenuItem";
import { MenuItemType } from "./constants";
import { useMenuItemLogic } from "./hooks";
import { MenuItemProps } from "./types";

export const MenuItem = (props: MenuItemProps) => {
  const { getMenuItemType, hasSubItems } = useMenuItemLogic();
  const { item, isCollapsed } = props;

  const menuType = getMenuItemType(item);

  // Simple item without sub-items
  if (menuType === MenuItemType.SIMPLE) {
    return <SimpleMenuItem {...props} />;
  }

  // Items with sub-items - use different components based on collapsed state
  if (hasSubItems(item)) {
    if (isCollapsed) {
      return <CollapsedMenuItem {...props} />;
    }
    return <ExpandedMenuItem {...props} />;
  }

  // Fallback to simple item
  return <SimpleMenuItem {...props} />;
};
